import { useState, useCallback } from "react";

export const useModalState = () => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isSendCustomerOpen, setIsSendCustomerOpen] = useState(false);
  const [isAddCustomerOpen, setIsAddCustomerOpen] = useState(false);
  const [isSuccessModal, setSuccessModal] = useState(false);
  const [isStatusError, setStatusError] = useState(false);

  const closeAllModals = useCallback(() => {
    setIsSuccessModalOpen(false);
    setIsSendCustomerOpen(false);
    setIsAddCustomerOpen(false);
    setSuccessModal(false);
    setStatusError(false);
  }, []);

  return {
    isSuccessModalOpen,
    isSendCustomerOpen,
    isAddCustomerOpen,
    isSuccessModal,
    isStatusError,
    setIsSuccessModalOpen,
    setIsSendCustomerOpen,
    setIsAddCustomerOpen,
    setSuccessModal,
    setStatusError,
    closeAllModals,
  };
};
